// THIS FILE IS AUTO-GENERATED. DO NOT EDIT MANUALLY.
// Run: sh packages/api-types/scripts/run_generate_api_types.sh

export type RuntimePrimitive = string | number | boolean | null

export type RuntimeSchema =
  | { kind: 'unknown' }
  | { kind: 'string' }
  | { kind: 'number' }
  | { kind: 'boolean' }
  | { kind: 'null' }
  | { kind: 'literal'; value: RuntimePrimitive }
  | { kind: 'array'; items: RuntimeSchema }
  | { kind: 'tuple'; items: readonly RuntimeSchema[] }
  | { kind: 'record'; values: RuntimeSchema }
  | { kind: 'union'; variants: readonly RuntimeSchema[] }
  | { kind: 'object'; fields: Readonly<Record<string, RuntimeObjectField>> }
  | { kind: 'lazy'; resolve: () => RuntimeSchema }

export interface RuntimeObjectField {
  schema: RuntimeSchema
  optional: boolean
}

export const unknownSchema: RuntimeSchema = { kind: 'unknown' }
export const stringSchema: RuntimeSchema = { kind: 'string' }
export const numberSchema: RuntimeSchema = { kind: 'number' }
export const booleanSchema: RuntimeSchema = { kind: 'boolean' }
export const nullSchema: RuntimeSchema = { kind: 'null' }
export const literalSchema = (value: RuntimePrimitive): RuntimeSchema => ({ kind: 'literal', value })
export const arraySchema = (items: RuntimeSchema): RuntimeSchema => ({ kind: 'array', items })
export const tupleSchema = (items: readonly RuntimeSchema[]): RuntimeSchema => ({ kind: 'tuple', items })
export const recordSchema = (values: RuntimeSchema): RuntimeSchema => ({ kind: 'record', values })
export const unionSchema = (variants: readonly RuntimeSchema[]): RuntimeSchema => ({ kind: 'union', variants })
export const objectSchema = (fields: Readonly<Record<string, RuntimeObjectField>>): RuntimeSchema => ({ kind: 'object', fields })
export const lazySchema = (resolve: () => RuntimeSchema): RuntimeSchema => ({ kind: 'lazy', resolve })

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value)

const describeValue = (value: unknown): string => {
  if (value === null) return 'null'
  if (Array.isArray(value)) return 'array'
  return typeof value
}

const validationIssue = (schema: RuntimeSchema, value: unknown, path: string): string | null => {
  switch (schema.kind) {
    case 'unknown':
      return null
    case 'string':
      return typeof value === 'string' ? null : `${path} must be a string, received ${describeValue(value)}`
    case 'number':
      return typeof value === 'number' && Number.isFinite(value) ? null : `${path} must be a finite number, received ${describeValue(value)}`
    case 'boolean':
      return typeof value === 'boolean' ? null : `${path} must be a boolean, received ${describeValue(value)}`
    case 'null':
      return value === null ? null : `${path} must be null, received ${describeValue(value)}`
    case 'literal':
      return Object.is(value, schema.value) ? null : `${path} must equal ${JSON.stringify(schema.value)}`
    case 'array': {
      if (!Array.isArray(value)) return `${path} must be an array, received ${describeValue(value)}`
      for (const [index, item] of value.entries()) {
        const issue = validationIssue(schema.items, item, `${path}[${index}]`)
        if (issue) return issue
      }
      return null
    }
    case 'tuple': {
      if (!Array.isArray(value)) return `${path} must be an array, received ${describeValue(value)}`
      if (value.length !== schema.items.length) return `${path} must contain ${schema.items.length} items, received ${value.length}`
      for (const [index, itemSchema] of schema.items.entries()) {
        const issue = validationIssue(itemSchema, value[index], `${path}[${index}]`)
        if (issue) return issue
      }
      return null
    }
    case 'record': {
      if (!isRecord(value)) return `${path} must be an object, received ${describeValue(value)}`
      for (const [key, item] of Object.entries(value)) {
        const issue = validationIssue(schema.values, item, `${path}.${key}`)
        if (issue) return issue
      }
      return null
    }
    case 'union':
      return schema.variants.some((variant) => validationIssue(variant, value, path) === null)
        ? null
        : `${path} does not match any allowed shape`
    case 'object': {
      if (!isRecord(value)) return `${path} must be an object, received ${describeValue(value)}`
      for (const [name, field] of Object.entries(schema.fields)) {
        if (!(name in value)) {
          if (!field.optional) return `${path}.${name} is required`
          continue
        }
        const issue = validationIssue(field.schema, value[name], `${path}.${name}`)
        if (issue) return issue
      }
      return null
    }
    case 'lazy':
      return validationIssue(schema.resolve(), value, path)
  }
}

export class RuntimeValidationError extends Error {
  constructor(context: string, issue: string) {
    super(`Invalid ${context}: ${issue}`)
    this.name = 'RuntimeValidationError'
  }
}

export const validateRuntimeValue = <T>(schema: RuntimeSchema, value: unknown, context: string): T => {
  const issue = validationIssue(schema, value, '$')
  if (issue) throw new RuntimeValidationError(context, issue)
  return value as T
}
